import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getOperatorId, handleChange, handleError, trimField } from '../Shared/Functions';
import { Button, CircularProgress, TextField } from '@mui/material';
import { withToast } from '../Shared/Toast';
import { UserUtilityVService } from '../../services/V2/keymaster';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const ChangePassword = ({errorToast, successToast}) => {
    let history = useHistory();
    const { resetId } = useParams<{ resetId: string }>();
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [model, setModel] = useState<any>()
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

    useEffect(() => {
        getOperatorId()
            .then(x => setModel({
                ...model,
                OperatorId: x,
                resetId: resetId
            }))
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => setModel({
        ...model,
        resetId: resetId
    }), [resetId])// eslint-disable-line react-hooks/exhaustive-deps

    const submit = () => {
        setSubmitting(true)
        UserUtilityVService.userUtilityVPasswordReset(model)
            .then(x => {
                successToast("Successfully changed your password.")
                history.push('/sign-in');
            })
            .catch(x =>
            {
                setSubmitting(false)
                errorToast(handleError(x))
            })
    }

    return <div style={{margin: "0px 15px"}}>
        <div><b>Password must contain at least 8 characters, 1 capital letter, 1 number, and 1 special character from the following list:</b></div>
        <div><b>{"# ? ! @ $ % ^ & + = < > ( ) _ { } ` , | [ ] - \\"}</b></div>
        <form>
            <TextField
                disabled={submitting}
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                name="newPassword"
                label="New Password"
                type={showPassword ? 'text' : 'password'}
                autoComplete="new-password"
                value={model?.newPassword ?? ""}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword(!showPassword)}
                                onMouseDown={e => e.preventDefault()}
                                edge="end"
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
            <TextField
                disabled={submitting}
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                name="confirmPassword"
                label="Confirm Password"
                type={showConfirmPassword ? 'text' : 'password'}
                autoComplete="new-password"
                value={model?.confirmPassword ?? ""}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                onMouseDown={e => e.preventDefault()}
                                edge="end"
                                >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
            <Button variant="contained"
                disabled={submitting}
                id="submit"
                style={{width: "100%"}}
                type="submit"
                color="primary"
                onClick={submit}>
                {submitting ?
                    <>
                        <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                    </> : 'Update Password'}
            </Button>
        </form>
    </div>
}

export default withToast(ChangePassword);